var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "rcd-wrap" }, [
        _c("div", { staticClass: "rcd-pc" }, [
          _c("div", { staticClass: "rcd-pc-info" }, [
            _c("span", { staticClass: "rcd-fire" }, [_vm._v("🔥")]),
            _c("div", { staticClass: "rcd-pc-text" }, [
              _c("span", { staticClass: "rcd-title" }, [
                _vm._v(_vm._s(_vm.$t("rebate_countdown_title"))),
              ]),
              _vm.rebate.rebate > 0
                ? _c("span", { staticClass: "rcd-rate" }, [
                    _vm._v(_vm._s(_vm.rebate.rebate * 100) + "%"),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "rcd-pc-divider" }),
          _c("div", { staticClass: "rcd-pc-countdown" }, [
            _c("span", { staticClass: "rcd-label" }, [
              _vm._v(_vm._s(_vm.$t("rebate_countdown_label"))),
            ]),
            _c("div", { staticClass: "rcd-blocks" }, [
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.days)),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_days"))),
                ]),
              ]),
              _c("span", { staticClass: "rcd-colon" }, [_vm._v(":")]),
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.pad(_vm.hours))),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_hours"))),
                ]),
              ]),
              _c("span", { staticClass: "rcd-colon" }, [_vm._v(":")]),
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.pad(_vm.minutes))),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_minutes"))),
                ]),
              ]),
              _c("span", { staticClass: "rcd-colon" }, [_vm._v(":")]),
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.pad(_vm.seconds))),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_seconds"))),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "rcd-mobile" }, [
          _c("div", { staticClass: "rcd-m-header" }, [
            _c("span", { staticClass: "rcd-fire" }, [_vm._v("🔥")]),
            _c("span", { staticClass: "rcd-title" }, [
              _vm._v(_vm._s(_vm.$t("rebate_countdown_title"))),
            ]),
            _c("span", { staticClass: "rcd-live-dot" }),
            _vm.rebate.rebate > 0
              ? _c("span", { staticClass: "rcd-rate" }, [
                  _vm._v(_vm._s(_vm.rebate.rebate * 100) + "%"),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "rcd-m-body" }, [
            _c("span", { staticClass: "rcd-label" }, [
              _vm._v(_vm._s(_vm.$t("rebate_countdown_label"))),
            ]),
            _c("div", { staticClass: "rcd-blocks" }, [
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.days)),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_days"))),
                ]),
              ]),
              _c("span", { staticClass: "rcd-colon" }, [_vm._v(":")]),
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.pad(_vm.hours))),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_hours"))),
                ]),
              ]),
              _c("span", { staticClass: "rcd-colon" }, [_vm._v(":")]),
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.pad(_vm.minutes))),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_minutes"))),
                ]),
              ]),
              _c("span", { staticClass: "rcd-colon" }, [_vm._v(":")]),
              _c("div", { staticClass: "rcd-unit" }, [
                _c("span", { staticClass: "rcd-num" }, [
                  _vm._v(_vm._s(_vm.pad(_vm.seconds))),
                ]),
                _c("span", { staticClass: "rcd-text" }, [
                  _vm._v(_vm._s(_vm.$t("rebate_countdown_seconds"))),
                ]),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }